import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import { CrudStore } from 'core/types/crudStore'

export const getUserCrud = () => CrudStore.get(CrudStoreItem.AppUsersAppsSearch)
